import { Link } from "react-router-dom";
import "../styles/HomeNew.css";

export default function NotFoundPage() {
  return (
    <div className="pg">
      <section className="hero" style={{ minHeight: "80svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr", textAlign: "center" }}>
          <div className="hero__text" style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
            <p className="hero__kicker">Error 404</p>
            <h1 className="hero__h1" style={{ fontSize: "clamp(4rem, 12vw, 10rem)", lineHeight: 1 }}>
              <span className="hero__accent">Oops!</span>
            </h1>
            <p className="hero__sub" style={{ textAlign: "center" }}>
              We couldn't find the page you're looking for. Please check the URL or navigate back to a page that exists.
            </p>
            <div className="hero__ctas" style={{ justifyContent: "center" }}>
              <Link to="/" className="cta cta--solid">← Back to Home</Link>
              <Link to="/projects" className="cta cta--ghost">View Projects</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}